import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();

  return (
    <div className="GaFa hero" id="hero">
      <Nav />
      <HeroFooter
        name={t("gaubert.hero.name")}
        link1url="https://fannyart.fr/"
        link2display={true}
        link2name={t("gaubert.hero.link2")}
        link2url="https://www.instagram.com/ph.gauberti/"
      />
    </div>
  );
}

export default Hero;
